import { Route } from '@angular/router';
import { KeycloakAuthComponent, keycloakGuard } from '@peca/keycloak';
import { PDSMainNavigationComponent } from '@peca/design-system';

import { securityGuard } from './core/guards/security.guard';

import { SellersModuleLoad } from './modules/sellers/sellers.routes';
import { ProductsModuleLoad } from './modules/products/products.routes';
import { CarriersModuleLoad } from './modules/carriers/carriers.routes';
import { BuyersModuleLoad } from './modules/buyers/buyers.routes';
import { OrdersModuleLoad } from './modules/orders/orders.routes';
import { VouchersModuleLoad } from './modules/vouchers/vouchers.routes';
import { DeliveriesModuleLoad } from './modules/deliveries/deliveries.routes';
import { SalesChannelsModuleLoad } from './modules/sales-channels/sales-channels.routes';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { PurchasesModuleLoad } from './modules/purchases/purchases.routes';
import { ForbiddenComponent } from './core/components/forbidden/forbidden.component';
import { ShippginsModuleLoad } from './modules/shippings/shippings.routes';
import { OrdersReturnModuleLoad } from './modules/orders-return/orders-return.routes';
import { TrackingtModuleLoad } from './modules/tracking/tracking.routes';
import { PlatformsModuleLoad } from './modules/platforms/platforms.routes';
import { UsersModuleLoad } from './modules/users/users.routes';
import { StockModuleLoad } from './modules/stock/stock.routes';
import { ReverseLogisticsModuleLoad } from './modules/reverse-logistics/reverse-logistics.routes';
import { OperationsModuleLoad } from './modules/operations/operations.routes';

export const routes: Route[] = [
  {
    path: '403',
    component: ForbiddenComponent,
  },
  {
    path: 'auth',
    component: KeycloakAuthComponent,
  },
  {
    path: '',
    component: PDSMainNavigationComponent,
    canActivate: [securityGuard(), keycloakGuard([])],
    children: [
      {
        path: 'vendas',
        loadChildren: OrdersModuleLoad,
        canActivate: [keycloakGuard(['vendas-listagem'])],
      },
      {
        path: 'vendedores',
        loadChildren: SellersModuleLoad,
        canActivate: [keycloakGuard(['vendedores-1', 'vendedores-2', 'vendedores-3'])],
      },
      {
        path: 'produtos',
        loadChildren: ProductsModuleLoad,
        canActivate: [keycloakGuard(['produtos-consulta'])],
      },
      {
        path: 'transportadoras',
        loadChildren: CarriersModuleLoad,
        canActivate: [keycloakGuard(['transportadoras-1', 'transportadoras-2', 'transportadoras-3'])],
      },
      {
        path: 'compradores',
        loadChildren: BuyersModuleLoad,
        canActivate: [
          keycloakGuard([
            'compradores-externos-1',
            'compradores-externos-2',
            'compradores-externos-3',
            'compradores-oficinas-1',
            'compradores-oficinas-2',
            'compradores-oficinas-3',
            'compradores-wom-1',
            'compradores-wom-2',
            'compradores-wom-3',
          ]),
        ],
      },
      {
        path: 'cupons',
        loadChildren: VouchersModuleLoad,
        canActivate: [keycloakGuard(['cupons-listagem'])],
      },
      {
        path: 'fretes',
        loadChildren: DeliveriesModuleLoad,
        canActivate: [keycloakGuard(['fretes-listagem'])],
      },
      {
        path: 'canais-de-venda',
        loadChildren: SalesChannelsModuleLoad,
        canActivate: [keycloakGuard(['canais-de-venda-1', 'canais-de-venda-2', 'canais-de-venda-3'])],
      },
      {
        path: 'compras',
        loadChildren: PurchasesModuleLoad,
        canActivate: [keycloakGuard(['compras-listagem'])],
      },
      {
        path: 'devolucoes',
        loadChildren: OrdersReturnModuleLoad,
        canActivate: [keycloakGuard(['devolucoes-listagem'])],
      },
      {
        path: 'logistica-reversa',
        loadChildren: ReverseLogisticsModuleLoad,
        canActivate: [keycloakGuard(['logística-reversa-listagem'])],
      },
      {
        path: 'entregas',
        loadChildren: ShippginsModuleLoad,
        canActivate: [keycloakGuard(['entregas-listagem'])],
      },
      {
        path: 'rastreios',
        loadChildren: TrackingtModuleLoad,
        canActivate: [keycloakGuard(['rastreios-listagem'])],
      },
      {
        path: 'gestao-de-plataforma',
        loadChildren: PlatformsModuleLoad,
        canActivate: [keycloakGuard(['plataformas-listagem'])],
      },
      {
        path: 'usuarios',
        loadChildren: UsersModuleLoad,
        canActivate: [keycloakGuard(['usuarios-listagem'])],
      },
      {
        path: 'estoque-e-preco',
        loadChildren: StockModuleLoad,
        canActivate: [keycloakGuard(['estoque-virtual-listagem'])],
      },
      {
        path: 'operacoes',
        loadChildren: OperationsModuleLoad,
        canActivate: [keycloakGuard(['operações-listagem'])],
      },
      {
        path: '',
        component: DashboardComponent,
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
];
